module.exports = __webpack_public_path__ + "assets/e9d1142fbd7784a3b3419acea43fb98e.png";